(function() {
  'use strict';

  var container = document.querySelector('[data-animation-intro]');
  if (!container) return;

  var SECTION_ID = container.getAttribute('data-section-id');
  var CONFIG_KEY = '__animIntroConfig_' + SECTION_ID.replace(/-/g, '_');

  /*
   * VISUAL_SCALE — The drawn image is this much larger than the physics circle.
   * This is the secret to zero gaps: physics circles leave triangular holes when
   * packed, but drawing the image at 1.6x the radius makes neighbors overlap
   * visually, creating a solid wall of ducks. Increase toward 1.8 if tiny gaps
   * remain; decrease toward 1.4 if images look too squished/overlapping.
   */
  var VISUAL_SCALE = 1.6;

  /* Absolute ceiling on bodies to protect performance */
  var MAX_BODIES = 1500;

  /* How many bodies to spawn per animation frame */
  var SPAWN_PER_FRAME_DESKTOP = 14;
  var SPAWN_PER_FRAME_MOBILE = 8;

  function boot() {
    var config = window[CONFIG_KEY];
    if (!config || !config.images || config.images.length < 2) {
      removeContainer();
      return;
    }

    loadImages(config.images).then(function(loaded) {
      if (loaded.length < 2) {
        removeContainer();
        return;
      }
      init(config, loaded);
    });
  }

  function removeContainer() {
    var el = document.getElementById('animation-intro-' + SECTION_ID);
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }

  function loadImages(urls) {
    return Promise.all(urls.map(function(url) {
      return new Promise(function(resolve) {
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function() { resolve(img); };
        img.onerror = function() { resolve(null); };
        img.src = url;
      });
    })).then(function(imgs) {
      return imgs.filter(Boolean);
    });
  }

  function init(config, loadedImages) {
    var container = document.getElementById('animation-intro-' + SECTION_ID);
    if (!container) return;

    // Teardown prior instance if exists
    if (container._animIntroDestroy) {
      container._animIntroDestroy();
    }

    var Matter = window.Matter;
    var Engine = Matter.Engine;
    var Runner = Matter.Runner;
    var Bodies = Matter.Bodies;
    var Body = Matter.Body;
    var Composite = Matter.Composite;

    var canvas = container.querySelector('.animation-intro__canvas');
    var ctx = canvas.getContext('2d');

    var w = window.innerWidth;
    var h = window.innerHeight;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var isMobile = w < 768;

    canvas.width = w * dpr;
    canvas.height = h * dpr;
    ctx.scale(dpr, dpr);

    // Lock body scroll
    document.body.classList.add('animation-intro-active');

    // Physics — gravity 1.0, low bounce so bodies compact tight
    var engine = Engine.create({ gravity: { x: 0, y: 1 } });
    var runner = Runner.create();

    var wallThickness = 80;
    var floorBody = Bodies.rectangle(w / 2, h + wallThickness / 2, w + 200, wallThickness, { isStatic: true });
    var leftWall = Bodies.rectangle(-wallThickness / 2, h / 2, wallThickness, h * 3, { isStatic: true });
    var rightWall = Bodies.rectangle(w + wallThickness / 2, h / 2, wallThickness, h * 3, { isStatic: true });

    Composite.add(engine.world, [floorBody, leftWall, rightWall]);
    Runner.run(runner, engine);

    var bodies = [];
    var imgIndex = 0;
    var startTime = null;
    var phase = 'filling'; // filling -> paused -> clearing
    var isDestroyed = false;
    var rafId = null;
    var floorRemoved = false;
    var fillStoppedAt = null; // timestamp when fill condition was met

    var spawnPerFrame = isMobile ? SPAWN_PER_FRAME_MOBILE : SPAWN_PER_FRAME_DESKTOP;

    // Scale spawn rate by density setting (1-10, default 6)
    // density 6 = 1x spawn rate, density 10 = ~1.7x, density 1 = ~0.17x
    var densityScale = config.density / 6;
    var adjustedSpawn = Math.max(2, Math.round(spawnPerFrame * densityScale));

    // Column balancing — divide viewport into columns, prefer spawning into shortest
    var NUM_COLS = 8;
    var colWidth = w / NUM_COLS;

    function getShortestCol() {
      var tops = [];
      for (var c = 0; c < NUM_COLS; c++) tops[c] = h;
      for (var i = 0; i < bodies.length; i++) {
        var bx = bodies[i].position.x;
        var by = bodies[i].position.y;
        var col = Math.floor(bx / colWidth);
        if (col < 0) col = 0;
        if (col >= NUM_COLS) col = NUM_COLS - 1;
        if (by < tops[col]) tops[col] = by;
      }
      var best = 0;
      var bestY = -Infinity;
      for (var c2 = 0; c2 < NUM_COLS; c2++) {
        if (tops[c2] > bestY) { bestY = tops[c2]; best = c2; }
      }
      return best;
    }

    function spawnOne() {
      var radius = 15;

      // 70% target shortest column, 30% random
      var col;
      if (Math.random() < 0.7) {
        col = getShortestCol();
      } else {
        col = Math.floor(Math.random() * NUM_COLS);
      }
      var x = col * colWidth + radius + Math.random() * Math.max(colWidth - radius * 2, 1);
      if (x < radius) x = radius;
      if (x > w - radius) x = w - radius;

      var y = -radius * 2 - Math.random() * 120;
      var img = loadedImages[imgIndex % loadedImages.length];
      imgIndex++;

      var body = Bodies.circle(x, y, radius, {
        restitution: 0.05,    // almost no bounce — compact immediately
        friction: 0.6,         // high friction — grip each other
        density: 0.001,
        frictionAir: 0.005     // slight air drag — settle faster
      });
      body._img = img;
      body._radius = radius;

      Composite.add(engine.world, body);
      bodies.push(body);
    }

    // Fill condition: pile has reached the top of the viewport.
    // Check if >=6 bodies are settled (low velocity) in the top 15% of screen.
    function isPileFull() {
      var topZone = h * 0.15;
      var count = 0;
      for (var i = 0; i < bodies.length; i++) {
        var b = bodies[i];
        if (b.position.y < topZone && b.position.y > 0 && Math.abs(b.velocity.y) < 1) {
          count++;
          if (count >= 6) return true;
        }
      }
      return false;
    }

    function triggerClear() {
      if (floorRemoved) return;
      floorRemoved = true;
      Composite.remove(engine.world, floorBody);

      var backdrop = container.querySelector('.animation-intro__backdrop');
      if (backdrop) {
        backdrop.style.transition = 'opacity 0.3s ease-out';
        backdrop.style.opacity = '0';
      }

      for (var i = 0; i < bodies.length; i++) {
        Body.applyForce(bodies[i], bodies[i].position, {
          x: (Math.random() - 0.5) * 0.02,
          y: 0.03
        });
      }
    }

    function allBodiesGone() {
      var limit = h + 100;
      for (var i = 0; i < bodies.length; i++) {
        if (bodies[i].position.y < limit) return false;
      }
      return true;
    }

    function fadeOutAndDestroy() {
      if (isDestroyed) return;
      container.style.transition = 'opacity 0.3s ease-out';
      container.style.opacity = '0';
      setTimeout(destroy, 320);
    }

    function renderLoop(timestamp) {
      if (isDestroyed) return;

      if (!startTime) startTime = timestamp;
      var elapsed = timestamp - startTime;
      var progress = elapsed / config.durationMs;

      // --- Phase: FILLING ---
      if (phase === 'filling') {
        var full = isPileFull();
        var capped = bodies.length >= MAX_BODIES;
        var timeUp = progress >= 0.65; // safety time cap

        if (full || capped || timeUp) {
          if (!fillStoppedAt) fillStoppedAt = timestamp;
          // 150ms settle before moving to pause
          if (timestamp - fillStoppedAt >= 150) {
            phase = 'paused';
          }
        } else {
          for (var s = 0; s < adjustedSpawn; s++) {
            if (bodies.length >= MAX_BODIES) break;
            spawnOne();
          }
        }
      }

      // --- Phase: PAUSED ---
      else if (phase === 'paused') {
        // Wait until 80% of total duration, then clear
        if (progress >= 0.80) {
          phase = 'clearing';
        }
      }

      // --- Phase: CLEARING ---
      else if (phase === 'clearing') {
        triggerClear();
        if (allBodiesGone()) {
          fadeOutAndDestroy();
          return;
        }
      }

      // Safety: force end if it's been way too long
      if (progress > 1.5) {
        fadeOutAndDestroy();
        return;
      }

      // --- Render ---
      ctx.clearRect(0, 0, w, h);

      for (var i = 0; i < bodies.length; i++) {
        var body = bodies[i];
        var pos = body.position;
        var angle = body.angle;
        var r = body._radius;
        var img = body._img;

        // Skip bodies far off-screen
        if (pos.y > h + r * 2 + 50 || pos.y < -r * 2 - 200) continue;
        if (pos.x < -r * 2 || pos.x > w + r * 2) continue;

        // Draw image larger than physics body to fill gaps between circles
        var vr = r * VISUAL_SCALE;

        ctx.save();
        ctx.translate(pos.x, pos.y);
        ctx.rotate(angle);
        ctx.drawImage(img, -vr, -vr, vr * 2, vr * 2);
        ctx.restore();
      }

      rafId = requestAnimationFrame(renderLoop);
    }

    // Start
    rafId = requestAnimationFrame(renderLoop);


    // Cleanup function
    function destroy() {
      if (isDestroyed) return;
      isDestroyed = true;

      if (runner) Runner.stop(runner);
      if (engine) {
        Composite.clear(engine.world, false);
        Engine.clear(engine);
      }
      if (rafId) cancelAnimationFrame(rafId);
      if (ctx) ctx.clearRect(0, 0, canvas.width, canvas.height);

      document.body.classList.remove('animation-intro-active');

      if (container && container.parentNode) {
        container.parentNode.removeChild(container);
      }

      // Null references
      engine = null;
      runner = null;
      bodies = null;
      loadedImages = null;

      // Clean up global config
      delete window[CONFIG_KEY];
    }

    // Store destroy ref for idempotent teardown
    container._animIntroDestroy = destroy;

    // Theme editor lifecycle
    document.addEventListener('shopify:section:unload', function onUnload(event) {
      if (event.detail && event.detail.sectionId === SECTION_ID) {
        document.removeEventListener('shopify:section:unload', onUnload);
        destroy();
      }
    });
  }

  // Wait for Matter.js to load
  if (window.Matter) {
    boot();
  } else {
    var attempts = 0;
    var poll = setInterval(function() {
      attempts++;
      if (window.Matter) {
        clearInterval(poll);
        boot();
      } else if (attempts > 100) {
        clearInterval(poll);
        removeContainer();
      }
    }, 50);
  }
})();
